import { useEffect } from 'react';

import {
  type TModePathInput,
  type TModePathResolver,
  useSpotlightAPI,
} from '@frontend/components/Spotlight/store';

/**
 * Push a mode frame while the calling component is mounted, popping it on unmount.
 * `input` may be a path string, a segments array, or a resolver that derives the
 * new path from the current top frame (for nesting under a parent mode). Pass a
 * stable (memoized or module-constant) reference — a new identity re-pushes. The
 * mount-driven counterpart to an action calling `pushMode` from its `execute`.
 */
export function useSpotlightMode(input: TModePathInput | TModePathResolver): void {
  const api = useSpotlightAPI();
  useEffect(() => api.pushMode(input), [api, input]);
}
